/**
 * A global namespace for `mouseover` event.
 */
const mouseoverEvent = "mouseover";
export default mouseoverEvent;
